export default __webpack_public_path__ + "static/mentionslegales-86992fc71aac203e33978523869ced2b.pdf";